import api, { unwrapList, unwrapOne } from "./apiClient";
import { BACKEND_URL } from "@/config/api";

const API_BASE = `${BACKEND_URL}/categories`;

/**
 * Category Service (CategoryController - /categories)
 * CategoryDTO: { id (chave texto, única por empresa), name, icon }
 */
class CategoryService {
  async getAll() {
    try {
      const response = await api.get(API_BASE);
      return unwrapList(response);
    } catch (error) {
      console.error("❌ Erro ao buscar categorias:", error);
      throw error;
    }
  }

  async getById(id) {
    try {
      const response = await api.get(`${API_BASE}/${encodeURIComponent(id)}`);
      return unwrapOne(response);
    } catch (error) {
      console.error(`❌ Erro ao buscar categoria ${id}:`, error);
      throw error;
    }
  }

  async create(category) {
    try {
      const response = await api.post(API_BASE, category);
      return unwrapOne(response);
    } catch (error) {
      console.error("❌ Erro ao criar categoria:", error);
      throw error;
    }
  }

  async update(id, category) {
    try {
      const response = await api.put(
        `${API_BASE}/${encodeURIComponent(id)}`,
        category,
      );
      return unwrapOne(response);
    } catch (error) {
      console.error(`❌ Erro ao atualizar categoria ${id}:`, error);
      throw error;
    }
  }

  async delete(id) {
    try {
      await api.delete(`${API_BASE}/${encodeURIComponent(id)}`);
    } catch (error) {
      console.error(`❌ Erro ao excluir categoria ${id}:`, error);
      throw error;
    }
  }
}

export default new CategoryService();
